// extracted by mini-css-extract-plugin
export var statItem = "_gl-1";
export var statsRow = "_gl-0";